/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Nav_EventsInputs */

const da_admin_nav_events = /** @type {(inputs: Admin_Nav_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hændelser`)
};

/** @type {(inputs: Admin_Nav_EventsInputs) => LocalizedString} */
const en_admin_nav_events = da_admin_nav_events;

/**

* @param {Admin_Nav_EventsInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const admin_nav_events = /** @type {((inputs?: Admin_Nav_EventsInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Nav_EventsInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_nav_events(inputs)
	return /** @type {LocalizedString} */ ("Hændelser")
});